import React from 'react';
import { editorial } from '../../mock';
import * as Icons from 'lucide-react';

const EditorialGrid = () => {
  return (
    <section className="bg-warm py-24 md:py-32 border-y border-divider">
      <div className="max-w-[1300px] mx-auto px-6 md:px-10">
        <div className="text-center reveal">
          <div className="gold-divider mb-4">
            <span className="chapter-badge text-gold uppercase">The Karma Difference</span>
          </div>
          <h2 className="font-serif-display text-navy text-4xl md:text-5xl leading-[1.1] font-medium">
            Six quiet promises.
          </h2>
          <p className="mt-4 font-serif-editorial text-navy/70 text-xl">
            Considered details that shape every Karma Experience.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {editorial.map((e) => {
            const Icon = Icons[e.icon] || Icons.Sparkles;
            return (
              <div
                key={e.title}
                className="reveal group border border-divider bg-cream overflow-hidden flex flex-col"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={e.image}
                    alt={e.title}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="px-7 py-7">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 rounded-full border border-gold/40 flex items-center justify-center">
                      <Icon size={16} className="text-gold" strokeWidth={1.4} />
                    </div>
                    <div className="chapter-badge text-gold uppercase">Karma</div>
                  </div>
                  <h3 className="font-serif-display text-navy text-2xl">{e.title}</h3>
                  <p className="mt-3 font-sans-body text-navy/75 text-[0.95rem] leading-relaxed">
                    {e.body}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EditorialGrid;
